export default function TenantScreen(){
    return(
        <div>Tenant Screen</div>
    )
}